import { Badge } from "@/components/ui/badge";
export default function PromotionalBanner() {
  return <section data-section-id="125490" id="hero" className="w-full bg-[var(--color-dark-background)] py-3 px-4 border-b-[var(--border-md)] border-[var(--color-accent)] overflow-hidden">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-center gap-3 text-center">
        <h2 className="font-display flex flex-col sm:flex-row items-center justify-center gap-3 m-0 w-full">
          <span className="text-[var(--color-accent)] font-black text-xl sm:text-2xl uppercase tracking-widest animate-pulse drop-shadow-sm">
            Smart Buy Savings
          </span>
          <span className="flex flex-wrap items-center justify-center gap-2 text-[var(--color-foreground-dark)] font-bold text-base sm:text-lg md:text-xl">
            <Badge variant="destructive" className="bg-[var(--color-secondary)] text-[var(--color-foreground-secondary)] border-[var(--border-thin)] border-[var(--color-secondary-light)] px-2.5 py-1 text-sm sm:text-base uppercase tracking-wider shadow-sm">
              Up to 50% Off
            </Badge>
            <span>Call (919) 703-0041 for Fast Delivery!</span>
          </span>
        </h2>
      </div>
    </section>;
}